module.exports = __webpack_public_path__ + "img/453.e9816a4b.jpg";